'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _semanticUiReact = require('semantic-ui-react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExternalLink = function ExternalLink(_ref) {
  var post = _ref.post;
  return _react2.default.createElement(_semanticUiReact.Popup, {
    trigger: _react2.default.createElement(
      'a',
      { target: '_blank', rel: 'noopener noreferrer', href: post.trackedAsset.assetURL },
      _react2.default.createElement(_semanticUiReact.Icon, { name: 'external' })
    ),
    content: 'view the asset on ' + _lodash2.default.toLower(post.trackedAsset.platform)
  });
};

ExternalLink.propTypes = {
  post: _propTypes2.default.object.isRequired
};

exports.default = ExternalLink;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/reports/external-link/index.js
 ** module id = 2615
 ** module chunks = 0
 **/